function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M45.82 34.852a4.037 4.037 0 000-5.704L25.878 9.18a4.025 4.025 0 00-5.698 0 4.037 4.037 0 000 5.705L37.273 32 20.18 49.114a4.037 4.037 0 000 5.705 4.025 4.025 0 005.698 0L45.82 34.852z",
  fill: "#2071bd",
  fillRule: "evenodd"
})));